import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { InputField } from "../../../../library/custom/textBox/InputField";
import Buttons from "../../../../library/custom/button/Button";
import { NumberField } from "../../../../library/custom/numberField/numberField";
import { COUNTRY_CODE, PAGE_SIZE } from "../../../../constant/constant";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";

const UserInfo = ({ userInfo, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [emailVerify, setEmailVerify] = useState("");
  const [phone, setPhone] = useState("");
  const [isSubmit, setIsSubmit] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
    const isValidEmail = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (e.target?.value && e.target.value.match(isValidEmail)) {
      setEmailVerify(false);
    } else {
      setEmailVerify(true);
    }
    setEmail(e.target.value);
    if (e.target.value === "") {
      setEmailVerify(false);
    }
  };
  const onChangePhone = (value) => {
    setPhone(value.length <= 10 ? value : phone);
    const phonePattern = /^\d{10}$/;
    if (value.length <= 10) {
      setPhoneError(!phonePattern.test(value));
    } else if (value.length === 0) {
      setPhoneError(false);
    } else {
      setPhoneError(false);
    }
  };

  function mappedData() {
    let errors = false;
    if (phone) {
      if (phoneError) {
        setPhoneError(true);
        errors = true;
      }
    } else {
      setPhoneError(false);
    }
    if (errors) {
      return false;
    }
    const data = {
      phonenumber: phone,
      email: email,
    };
    return data;
  }

  const submitData = () => {
    const data = mappedData();
    if (!data) {
    } else {
      onSubmit(data);
    }
  };

  useEffect(() => {
    if ((email || phone) && !emailVerify) {
      setIsSubmit(false);
    } else {
      setIsSubmit(true);
    }
  }, [email, phone]);

  useEffect(() => {
    if (!email && !phone) {
      const data = {
        phonenumber: "",
        email: "",
      };
      onSubmit(data);
    }
  }, [email, phone]);

  const renderClientName = (clientName) => {
    if (Array.isArray(clientName)) {
      return clientName.map((client, index) => (
        <div key={index}>
          {typeof client === "object" ? client.fullName : client}
        </div>
      ));
    }
    return clientName;
  };

  const columns = [
    {
      field: "userName",
      headerName: "User Name",
      flex: 1,
      renderCell: (params) => params?.row?.userName || "NA",
    },
    {
      field: "userId",
      headerName: "User Id",
      flex: 1,
      renderCell: (params) => params?.row?.userId || "NA",
    },
    {
      field: "clientName",
      headerName: "Client Name",
      flex: 1.5,
      renderCell: (params) => renderClientName(params?.row?.clientName) || "NA",
    },
    {
      field: "dateOfOnboarded",
      headerName: "Date of Onboarded",
      flex: 1,
      renderCell: (params) => params?.row?.dateOfOnboarded || "NA",
    },
    {
      field: "email",
      headerName: "Email ID",
      flex: 1.5,
      renderCell: (params) => (
        <div title={params?.row?.emailId || params?.row?.email || "NA"}>
          {params?.row?.emailId || params?.row?.email || "NA"}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Phone Number",
      flex: 1,
      renderCell: (params) =>
        params?.row?.phoneNumber || params?.row?.mobile || "NA",
    },
    {
      field: "userType",
      headerName: "User Type",
      flex: 1,
      renderCell: (params) => params?.row?.userType || "NA",
    },
  ];

  return (
    <>
      <Grid item container spacing={2} md={12} className="CategoriesBox">
        <Grid item md={4} xs={12} mb={2}>
          <InputField
            type="text"
            isRequired={false}
            value={email}
            onChange={(e) => onChangeEmail(e)}
            label="Enter Email ID"
            placeholder="Enter Email Here..."
            isError={false}
            errorMsg={false}
          />
          {emailVerify && (
            <div className="errorMsg">Please enter a valid Email address</div>
          )}
        </Grid>
        <Grid item md={4} xs={12} mb={2}>
          <NumberField
            // disabled={editMode ? true : false}
            isRequired={false}
            type="text"
            label={"Phone Number"}
            maxLength="10"
            value={phone}
            placeholder={`Enter Phone number without ${COUNTRY_CODE}`}
            onChange={(value) => onChangePhone(value)}
          />
          {phoneError && (
            <p className="errorMsg">Please enter valid phone number</p>
          )}
        </Grid>

        <Grid className="smallAddBtn" item lg={1.5} md={3} xs={3} ml={3} mt={4}>
          <Buttons
            varientContained={true}
            label={"Verify"}
            onClick={submitData}
            disabled={isSubmit ? true : false}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid container item md={12} xs={12}>
          <Grid item md={12} className="CategoriesBox" mt={3}>
            <div className="desc_box row_uniq">
              <div className="table_style_ui inspectionSet">
                <GridTable
                  getRowId={(row) => row.userId}
                  rows={userInfo?.result || []}
                  rowCount={userInfo?.result?.length || 0}
                  columns={columns}
                  loading={false}
                  checkboxSelection={false}
                  page={0}
                  pagination={false}
                  pageSize={PAGE_SIZE}
                  rowsPerPageOptions={[PAGE_SIZE]}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default UserInfo;
